/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "service": {
                    "nested": {
                      "CategoryEnablementForCombos": {
                        "fields": {
                          "categoryId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "globalEnablement": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional"
                          },
                          "locationIdsWhereCategoryCanBeFulfilled": {
                            "type": "string",
                            "id": 3,
                            "rule": "repeated"
                          },
                          "locationIdsWhereCategoryCanNotBeFulfilled": {
                            "type": "string",
                            "id": 4,
                            "rule": "repeated"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.CategoryEnablementForCombos) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc The global enablement for the category or the location ids where the category can be fulfilled
 * This field contains the subset of the category's enablements where at least one sellable, fixed-price variation is enabled
 * --
 *
 * SOURCE CategoryEnablementForCombos @ squareup/connect/v2/catalog/interfaces/interfaces-common.proto at 16:1
 */
export const CategoryEnablementForCombos = $root.lookupType('squareup.connect.v2.merchant_catalog.service.CategoryEnablementForCombos');
fixType(CategoryEnablementForCombos);
Builder.createAndAttachToType(CategoryEnablementForCombos);